"use client";

import Image from "next/image";
import Link from "next/link";

const LINK_ROW_CLASS =
  "group flex items-center gap-3 transition-all duration-300 hover:text-gray-light dark:hover:text-gray-dark";
const SHAPE_WRAP_CLASS =
  "relative h-4 w-4 opacity-60 transition-all duration-300 group-hover:opacity-100";

export interface FooterLinkItem {
  label: string;
  href: string;
  shape?: string;
}

interface FooterLinkListProps {
  items: readonly FooterLinkItem[];
  hoveredLink: string | null;
  setHoveredLink: (href: string | null) => void;
}

export default function FooterLinkList({
  items,
  hoveredLink,
  setHoveredLink,
}: FooterLinkListProps) {
  return (
    <ul className="space-y-3">
      {items.map((item) => (
        <li key={item.href}>
          <Link
            href={item.href}
            className={LINK_ROW_CLASS}
            onMouseEnter={() => setHoveredLink(item.href)}
            onMouseLeave={() => setHoveredLink(null)}
          >
            {item.shape ? (
              <div className={SHAPE_WRAP_CLASS}>
                <Image
                  src={item.shape}
                  alt=""
                  fill
                  className={`transform transition-all duration-300 ${
                    hoveredLink === item.href
                      ? "scale-125 rotate-12"
                      : "scale-100 rotate-0"
                  } group-hover:filter-none`}
                />
              </div>
            ) : null}
            <span
              className={`relative transition-transform duration-300 ${
                hoveredLink === item.href ? "transform translate-x-1" : ""
              }`}
            >
              {item.label}
              <span className="absolute -bottom-px left-0 h-px w-0 bg-current transition-all duration-300 group-hover:w-full" />
            </span>
          </Link>
        </li>
      ))}
    </ul>
  );
}
